import { Injectable, ComponentFactoryResolver } from '@angular/core';
import { LyOverlayContainer } from './overlay-container.component';
var DomService = /** @class */ (function () {
    function DomService(componentFactoryResolver, overlayContainer) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.overlayContainer = overlayContainer;
    }
    DomService.prototype.attach = function (_hostViewContainerRef, component, template) {
        var _this = this;
        var viewRef = _hostViewContainerRef.createEmbeddedView(template);
        viewRef.detectChanges();
        this._viewContainerRef = _hostViewContainerRef;
        viewRef.rootNodes.forEach(function (rootNode) { return _this.addChild(rootNode); });
    };
    DomService.prototype.addChild = function (child) {
        this.overlayContainer.containerElement.appendChild(child);
    };
    DomService.prototype.getDomElementFromComponentRef = function (componentRef) {
        return componentRef.hostView
            .rootNodes[0];
    };
    DomService.prototype.destroyRef = function (componentRef, delay) {
        var _this = this;
        setTimeout(function () {
            if (_this._viewContainerRef) {
                _this._viewContainerRef.detach();
                _this._viewContainerRef.clear();
            }
        }, delay);
    };
    DomService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    DomService.ctorParameters = function () { return [
        { type: ComponentFactoryResolver, },
        { type: LyOverlayContainer, },
    ]; };
    return DomService;
}());
export { DomService };
//# sourceMappingURL=dom.service.js.map